import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '../auth';
import { isKioskUser } from '../kioskSession';
import { isKioskPathAllowed } from '../Kiosk/kioskScope';

function ProtectedRoute({ children }) {
    const { user, loading, expired } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div>Loading...</div>;
    }

    // `expired` is the takeover: it signed the trainer out where they stood and holds this
    // route open behind its overlay, so the page and its in-progress state (a half-written
    // report, an open wizard) are still there when they sign back in. Navigating to /login
    // here would unmount the very thing the takeover exists to protect.
    if (!user && !expired) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // The server is the boundary; this keeps a trainer who types or bookmarks a manager URL on
    // the shared iPad from landing on a page that would only show refusals. `/` stays open:
    // HomePage builds a kiosk-safe list itself.
    if (isKioskUser(user) && location.pathname !== '/' && !isKioskPathAllowed(location.pathname)) {
        return <Navigate to="/hero-trainer-center" replace />;
    }

    return children;
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedRoute;